import { AlgoliaProductHit } from "../components/types/HitProps";
import { isBot } from "./BotUtils";

export const HitUrl = (hit: AlgoliaProductHit): string => {
  let url = "";
  if (hit.url) {
    if (isBot()) {
      url = hit.url;
    } else {
      const urlObj = new URL(hit.url, window.location.href);
      if (hit.__queryID) {
        urlObj.searchParams.set("queryID", hit.__queryID);
      }
      url = urlObj.toString();
    }
  }

  return url;
};

export const HitImages = (hit: AlgoliaProductHit): string[] => {
  const imageUrls: string[] = [];
  if (hit.imageUrl) {
    imageUrls.push(hit.imageUrl);
  }
  if (hit.hoverImageUrl) {
    imageUrls.push(hit.hoverImageUrl);
  }

  return imageUrls;
};
